import { hooks, Button, Flex, Icon, Link, Text } from '@bitrise/bitkit';
import React, { useContext, FunctionComponent } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import useDownloadConfigAndroid from './useDownloadConfigAndroid';
import useDownloadConfigIOS from './useDownloadConfigIOS';
import { AuthContextFirebase } from '../Authenticate/AuthenticateFirebase';

const { useCopyToClipboard } = hooks;

const SDKConfig: FunctionComponent = () => {
  const {
    data: { appId, serviceToken },
  } = useContext(AuthContextFirebase);
  const [refCopyToClipboard] = useCopyToClipboard();
  const handleDownloadAndroidConfig = useDownloadConfigAndroid();
  const handleDownloadIOSConfig = useDownloadConfigIOS();

  return (
    <Flex>
      <Text config="4" margin="x2">
        SDK token & config files
      </Text>

      <Text margin="x1">
        If you are not using the trace-step in the Bitrise workflow editor, please ensure this token
        is set in the SDK configuration. This is done by adding the correct config file for your
        project. For more guidance please see the{' '}
        <Link Component={RouterLink} color="grape-3" to={`/${appId}/o/getting-started`}>
          Getting Started
        </Link>{' '}
        documentation.
      </Text>

      <Flex direction="horizontal" gap="x4" margin="x5">
        <Flex grow initial="none">
          <Flex alignChildrenVertical="middle" direction="horizontal" gap="x4">
            <Flex>
              <Icon name="PlatformsApple" />
            </Flex>

            <Flex>
              <Text weight="bold">iOS</Text>
            </Flex>
          </Flex>

          <Button level="secondary" margin="x2" onClick={handleDownloadIOSConfig} size="small">
            Download Cocoapods & SPM
          </Button>
        </Flex>

        <Flex grow initial="none">
          <Flex alignChildrenVertical="middle" direction="horizontal" gap="x4">
            <Flex>
              <Icon name="PlatformsAndroid" />
            </Flex>

            <Flex>
              <Text weight="bold">Android</Text>
            </Flex>
          </Flex>

          <Button level="secondary" margin="x2" onClick={handleDownloadAndroidConfig} size="small">
            Download Gradle
          </Button>
        </Flex>

        <Flex grow initial="none">
          <Flex alignChildrenVertical="middle" direction="horizontal" gap="x4">
            <Flex>
              <Icon name="Key" />
            </Flex>

            <Flex>
              <Text weight="bold">SDK token</Text>
            </Flex>
          </Flex>

          <Button
            data-clipboard-text={serviceToken}
            level="secondary"
            margin="x2"
            innerRef={refCopyToClipboard}
            size="small"
          >
            Copy Token
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SDKConfig;
